module.exports = __webpack_public_path__ + "static/img/54eea5f0.svg";